export var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export var days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
export var TYPE_POPUP = {
    DATE: 'DATE',
    MONTH: 'MONTH',
    YEAR: 'YEAR'
};
export var isValidDate = function (dateString) {
    var regex = /^(?:(29|30)(\/|-|\.)((0?[13-9]|1[0-2])\4))|(?:(?:31(\/|-|\.)(0?[13578]|1[02])\1)|((0?[1-9]|1\d|2[0-8])(\/|-|\.)(0?[1-9]|1[0-2])\7))(\/|-|\.)\d{4}$|^(29(\/|-|\.)0?2\11(?:(?:(?:\d{2}(?:0[48]|[2468][048]|[13579][26]))|(?:[2468][048]00|[13579][26]00))))$/;
    if (!regex.test(dateString)) {
        return false;
    }
    // Parse day, month, year to check for valid date
    var _a = dateString.split('/'), day = _a[0], month = _a[1], year = _a[2];
    // Check if the parsed date matches the input date
    if (day.length !== 2 || month.length !== 2 || year.length !== 4) {
        return false;
    }
    return true;
};
export var getFormattedDate = function (date) {
    var _date = date || new Date();
    var yyyy = _date.getFullYear();
    var mm = _date.getMonth() + 1; // Months start at 0!
    var dd = _date.getDate();
    if (dd < 10)
        dd = "0".concat(dd);
    if (mm < 10)
        mm = "0".concat(mm);
    return "".concat(dd, "/").concat(mm, "/").concat(yyyy);
};
export var isDateInRange = function (date, selectedDate) {
    if (typeof selectedDate !== 'object')
        return false;
    if (!selectedDate[0] || !selectedDate[1])
        return false;
    return date >= selectedDate[0] && date <= selectedDate[1];
};
export var isStartDate = function (date, selectedDate) { var _a; return typeof selectedDate === 'object' && selectedDate[0] && ((_a = selectedDate[0]) === null || _a === void 0 ? void 0 : _a.toDateString()) === date.toDateString(); };
export var isEndDate = function (date, selectedDate) { var _a; return typeof selectedDate === 'object' && selectedDate[1] && ((_a = selectedDate[1]) === null || _a === void 0 ? void 0 : _a.toDateString()) === date.toDateString(); };
export var isSelectedDate = function (date, selectedDate) {
    if (!date || !selectedDate)
        return false;
    return date.toDateString() === selectedDate.toDateString();
};
export function convertStringToDate(dateString, format) {
    var parts = dateString.split('/');
    var day, month, year;
    var formatValue = format.toLowerCase();
    if (formatValue === 'dd/mm/yyyy') {
        ;
        day = parts[0], month = parts[1], year = parts[2];
    }
    else if (formatValue === 'mm/dd/yyyy') {
        ;
        month = parts[0], day = parts[1], year = parts[2];
    }
    else if (formatValue === 'yyyy/mm/dd') {
        ;
        year = parts[0], month = parts[1], day = parts[2];
    }
    return new Date(Number(year), Number(month) - 1, Number(day)); // tháng cần trừ 1
}
export function convertToDate(date) {
    var parts = (date || '').split('/');
    var day = parts[0], month = parts[1], year = parts[2];
    return new Date("".concat(year, "-").concat(month, "-").concat(day));
}
export function isDateValidInRange(_a) {
    var date = _a.date, max = _a.max, min = _a.min;
    return convertToDate(date) > convertToDate(min) && convertToDate(date) < convertToDate(max);
}
